import { create } from 'zustand';

interface UnsavedChangesState {
  /** True while an open form has edits the user has not saved. */
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
}

/**
 * Tracks whether the currently open form has unsaved edits. A child form (e.g.
 * Settings > Account) holds its own dirty state, but the navigation that can
 * discard it — the settings tab links — lives in a parent layout. This shared
 * flag lets the parent warn before navigating away. The owning form is
 * responsible for clearing the flag on unmount.
 */
export const useUnsavedChangesStore = create<UnsavedChangesState>((set) => ({
  isDirty: false,
  setIsDirty: (isDirty) => set({ isDirty }),
}));
